<template>
    <div class="epf-filter__checkboxes" :class="additionalClass">
        <div class="epf-filter__checkboxes__title">{{ filterConfig.title }}</div>
        <div class="epf-filter__checkboxes__wrap">
            <global-input-checkbox
                v-for="option in availableOptions"
                :key="option.value || option"
                :value="isOptionSelected(option)"
                @input="toggleOption(option)"
                :label="option.title || option.value || option"
                :disabled="$store.state.freeze"
                :title="checkboxTitle(option)">
            </global-input-checkbox>
        </div>
        <!--        <div class="epf-filter__buttons__footnote"><small v-show="selectedOption.footnote">({{ selectedOption.footnote }})</small></div>-->
    </div>
</template>

<script>
import GlobalButton from '@global/global-elements/global-button/global-button';
import GlobalInputCheckbox from "@global/global-elements/global-input-checkbox/global-input-checkbox.vue";

export default {
    name: "EpfFilterCheckboxes",
    components: {GlobalInputCheckbox, GlobalButton},
    props: {
        filterConfig: Object,
        additionalClass: ''
    },
    computed: {
        selectedValues() {
            const value = this.$store.getters.filterValueByName(this.filterConfig.name)
            if (value) {
                return value.split('__');
            }
            return [];
        },
        availableOptions() {
            return this.filterConfig.options;
        }
    },
    methods: {
        checkboxTitle: function(option) {
            if (option.footnote === undefined) {
                return '';
            }
            let tmp = document.createElement("DIV");
            tmp.innerHTML = option.footnote;
            let title = tmp.textContent || tmp.innerText || "";
            title = title.replaceAll(/\s{2,}/g, ' ');
            return title.trim();
        },
        isOptionSelected: function(option) {
            if (option.value) {
                return this.selectedValues.includes(option.value);
            }
            return this.selectedValues.includes(option);
        },
        toggleOption: function(optionToToggle) {
            let newValue = '';
            this.availableOptions.forEach((option) => {
                let addOption = this.isOptionSelected(option); // add all previously selected options
                if (option === optionToToggle) {
                    addOption = !addOption; // invers the value for the toggled option
                }
                if (addOption) {
                    if (newValue.length > 0) {
                        newValue += '__';
                    }
                    newValue += option.value || option;
                }
            });

            if (newValue.length > 0) {
                this.$store.dispatch('setFilterState', {
                    filterName: this.filterConfig.name,
                    value: newValue
                });
            } else {
                this.$store.dispatch('setFilterState', {
                    filterName: this.filterConfig.name,
                    value: null
                });
            }
        }
    }
}
</script>
